import React from 'react'
import {graphql} from 'gatsby'
import {Asset} from '../../../../plugins/gatsby-plugin-atollon'

const AboutBanner = ({image, video, short}) => {
  return (
    <section className={`about-banner${short ? ' about-banner--short' : ''}`}>
      <div className='about-banner__asset' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
        {video && <video className='about-banner__video' poster={image?.url} src={video} autoPlay loop muted playsInline /> }
        {image && <Asset className='about-banner__bg' asset={image}/>}
      </div>
    </section>
  )
}

export default AboutBanner

export const query = graphql`
  fragment AboutBannerProps on DatoCmsAboutBanner {
    ... on DatoCmsAboutBanner {
      id
      image {
        ...InternalAssetProps
      }
      video
      short
    }
  }
`;
